<form [formGroup]="form" class="flex-column">
  <div class="flex-row gap-16">
    <mat-form-field class="full-width">
      <mat-label>{{ 'UTILITIES.TOOL.CAVITIES.CAVITIES' | bmsTranslate }}</mat-label>
      <input matInput type="number" vdwL10nDecimal min="1" formControlName="cavities" placeholder="1" />
      @if (form.controls?.cavities?.value !== null) {
        <button class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="form.controls?.cavities.reset()">
          <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
        </button>
      }
      <mat-error *vdwCanShowErrorForFormControl="'cavities'; error: 'min'">
        <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1}" [compact]="true"></vdw-invalid-form-message>
      </mat-error>
      <mat-error *vdwCanShowErrorForFormControl="'cavities'; error: 'lowerThanUsedCavities'">
        <vdw-invalid-form-message [message]="'UTILITIES.TOOL.CAVITIES.LOWER_THAN_USE_CAVITIES_ERRORS' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
      </mat-error>
      <mat-error *vdwCanShowErrorForFormControl="'cavities'; error: 'equalToCavitiesAcrossAndDown'">
        <vdw-invalid-form-message [message]="'UTILITIES.TOOL.CAVITIES.EQUAL_TO_CAVITIES_ACROSS_AND_DOWN_ERRORS' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
      </mat-error>
    </mat-form-field>
    @if (isCavitiesGreaterThanOne()) {
      <mat-form-field class="full-width">
        <mat-label>{{ 'UTILITIES.TOOL.CAVITIES.USED_CAVITIES' | bmsTranslate }}</mat-label>
        <input matInput type="number" vdwL10nDecimal min="1" formControlName="usedCavities" placeholder="0" />
        @if (form.controls?.usedCavities?.value !== null) {
          <button class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="form.controls?.usedCavities.reset()">
            <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
          </button>
        }
        <mat-error *vdwCanShowErrorForFormControl="'usedCavities'; error: 'min'">
          <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1}" [compact]="true"></vdw-invalid-form-message>
        </mat-error>
        <mat-error *vdwCanShowErrorForFormControl="'usedCavities'; error: 'higherThanCavities'">
          <vdw-invalid-form-message [message]="'UTILITIES.TOOL.CAVITIES.HIGHER_THAN_CAVITIES_ERRORS' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
        </mat-error>
      </mat-form-field>
    }
  </div>
  @if (isCavitiesGreaterThanOne()) {
    <mat-form-field class="full-width">
      <mat-label>{{ 'UTILITIES.TOOL.CAVITIES.NUMBERING_MODE.NUMBERING_MODE' | bmsTranslate }}</mat-label>
      <mat-select
        disableOptionCentering
        formControlName="numberingMode"
        [placeholder]="'GENERAL.ACTIONS.SELECT_OBJECT' | bmsTranslate: {object: 'UTILITIES.TOOL.CAVITIES.NUMBERING_MODE.NUMBERING_MODE' | bmsTranslate | lowercase}"
        panelClass="bms-theme"
      >
        @for (numberingMode of numberingModes; track $index) {
          <mat-option [value]="numberingMode"> {{ 'UTILITIES.TOOL.CAVITIES.NUMBERING_MODE.' + numberingMode | bmsTranslate }} </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  @if (isCavitiesGreaterThanOne()) {
    <div class="flex-row gap-16">
      <mat-form-field class="full-width">
        <mat-label>{{ 'UTILITIES.TOOL.CAVITIES.CAVITIES_ACROSS' | bmsTranslate }}</mat-label>
        <input matInput type="number" vdwL10nDecimal min="0" formControlName="cavitiesAcross" placeholder="0" />
        @if (form.controls?.cavitiesAcross?.value !== null) {
          <button class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="form.controls?.cavitiesAcross.reset()">
            <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
          </button>
        }
        <mat-error *vdwCanShowErrorForFormControl="'cavitiesAcross'; error: 'min'">
          <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 0}" [compact]="true"></vdw-invalid-form-message>
        </mat-error>
        <mat-error *vdwCanShowErrorForFormControl="'cavitiesAcross'; error: 'equalToCavities'">
          <vdw-invalid-form-message [message]="'UTILITIES.TOOL.CAVITIES.EQUAL_TO_CAVITIES_ERRORS' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>{{ 'UTILITIES.TOOL.CAVITIES.CAVITIES_DOWN' | bmsTranslate }}</mat-label>
        <input matInput type="number" vdwL10nDecimal min="0" formControlName="cavitiesDown" placeholder="0" />
        @if (form.controls?.cavitiesDown?.value !== null) {
          <button class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="form.controls?.cavitiesDown.reset()">
            <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
          </button>
        }
        <mat-error *vdwCanShowErrorForFormControl="'cavitiesDown'; error: 'min'">
          <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 0}" [compact]="true"></vdw-invalid-form-message>
        </mat-error>
        <mat-error *vdwCanShowErrorForFormControl="'cavitiesDown'; error: 'equalToCavities'">
          <vdw-invalid-form-message [message]="'UTILITIES.TOOL.CAVITIES.EQUAL_TO_CAVITIES_ERRORS' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
        </mat-error>
      </mat-form-field>
    </div>
  }
  <mat-form-field class="full-width">
    <mat-label>{{ 'UTILITIES.TOOL.CAVITIES.PIECE_CYCLES' | bmsTranslate }}</mat-label>
    <input matInput type="number" vdwL10nDecimal min="1" formControlName="pieceCycles" placeholder="1" />
    @if (form.controls?.pieceCycles?.value !== null) {
      <button class="clear-input-button" tabindex="-1" mat-icon-button (click)="form.controls?.pieceCycles.reset()">
        <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
      </button>
    }
    <mat-error *vdwCanShowErrorForFormControl="'pieceCycles'; error: 'min'">
      <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1}" [compact]="true"></vdw-invalid-form-message>
    </mat-error>
  </mat-form-field>
</form>
